import { Component, Input } from '@angular/core';
import { TrafficLights } from '@app/pcs/models';
import { GridCell } from 'ngrx-data-grid';

@Component({
  templateUrl: './traffic-lights-column.component.html'
})
export class TrafficLightsColumnComponent implements GridCell<TrafficLights[]> {
  @Input() data: TrafficLights[];

}
